import { StatusBadge } from '../ui/StatusBadge';
import type { Insight } from '../../types/health';
import './InsightCard.css';

export function InsightCard({ insight }: { insight: Insight }) {
  return (
    <article className="insight-card">
      <div>
        <StatusBadge tone="primary">{insight.type}</StatusBadge>
        <h3>{insight.title}</h3>
        <p>{insight.description}</p>
      </div>
      <div className="insight-confidence numeric">{Math.round(insight.confidence * 100)}% confidence</div>
    </article>
  );
}
